import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { automationApi, type ApprovalRequest } from '../../api/automation';
import { HumanInTheLoopPanel } from '../../components/automationstudio/HumanInTheLoopPanel';

export function ApprovalCenterPage() {
  const [approvals, setApprovals] = useState<ApprovalRequest[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void automationApi.listApprovals().then((r) => setApprovals(r.approvals ?? [])).catch((e) => setError(String(e)));
  }, []);

  const panelTasks = approvals.map((a) => ({
    title: `Approval for execution ${a.execution_id.slice(0, 8)}`,
    mode: 'Approval Mode',
    agent: 'Workflow Engine',
    priority: 'high',
  }));

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Approval Center</h1>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Human-in-the-loop approvals, escalations and review queues.</p>
        </div>
        <Link to="/automation" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Automation Hub</Link>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6">
        <HumanInTheLoopPanel items={panelTasks} />
      </div>
    </div>
  );
}
